﻿
export enum TranslationMode {
	Full = "full",
	Partial = "partial"
}
